(() => {
    const $siteHeader = document.querySelector('.site-header-main');

    const $anchorLinks = document.querySelectorAll('.anchor-link');
    
    $anchorLinks.forEach($anchorLink => {
        $anchorLink.addEventListener('click', e => {
            const url = new URL($anchorLink.href);

            if ( !url.hash ) return;

            const $target = document.querySelector(url.hash);

            if (!$target) return;

            window.scroll({
                top: $target.getBoundingClientRect().y + window.scrollY - $siteHeader?.offsetHeight,
                behavior: 'smooth'
            });
            
            e.preventDefault();
        });
    });
})();
